import "../../global.css";
import "../product/importProducts.css";
import CustomGrid from "../../components/grid/CustomGrid";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getProducts } from "../../redux/apiCalls";
import { useState } from "react";
import * as XLSX from "xlsx";
import { userRequest } from "../../requestMethods";
import Swal from "sweetalert2";
import { generateFileUrl } from "../../requestMethods";
import { useCompany } from "../../components/context/CompanyContext";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";

export default function ImportProducts() {
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);
  const [dataXLS, setDataXLS] = useState([]);
  const { companyId } = useCompany();

  const columns = [
    {
      field: "categoryId",
      headerName: "ID Categoria",
      width: 1,
      align: "left",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "category",
      align: "left",
      headerName: "Categoria",
      width: 200,
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "subCategory",
      align: "left",
      headerName: "SubCategoria",
      width: 200,
      headerClassName: "dataGridMuiHeader",
    },
  ];

  const addXLS = async () => {
    if (dataXLS.length > 0) {
      const cat = Array.from(dataXLS).map((item) => ({
        category: item.category,
        subCategory: item.subCategory,
      }));

      const res = await userRequest.post(
        `${companyId}/products/categories/import`,
        cat
      );

      if (Object.keys(res.data).length > 0) {
        Swal.fire("Parabéns!", "Categorias adicionado com sucesso!", "success");
      } else {
        Swal.fire("Erro!", "Erro ao gravar as categorias!", "warning");
      }
    } else {
      Swal.fire("Atenção!", "Favor selecionar um aquivo!", "warning");
    }
  };

  const handleFileUpload = (e) => {
    const reader = new FileReader();
    reader.readAsBinaryString(e.target.files[0]);
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary" });

      if (validaFile(workbook)) {
        const index = workbook.SheetNames.findIndex(
          (item) => item === "Categorias"
        );
        const sheetName = workbook.SheetNames[index];
        const sheet = workbook.Sheets[sheetName];

        sheet["A1"].w = "category";
        sheet["B1"].w = "subCategory";

        const parsedData = XLSX.utils.sheet_to_json(sheet);
        setDataXLS(parsedData);
      } else {
        Swal.fire("Erro!", "Estrutura do arquivo modificada.", "warning");
      }
    };
  };

  const validaFile = (workbook) => {
    const index = workbook.SheetNames.findIndex(
      (item) => item === "Categorias"
    );
    const sheetName = workbook.SheetNames[index];
    const sheet = workbook.Sheets[sheetName];

    if (index === -1) {
      return false;
    }
    if (sheet["A1"].v !== "Categoria") {
      return false;
    }
    if (sheet["B1"].v !== "Subcategoria") {
      return false;
    }

    return true;
  };
  let downalodFIle = generateFileUrl("ImportFiles/ImportarCategorias.xlsx");
  return (
    <div className="cust-page">
      <div className="cust-toolbar">
        <input id="selecao-arquivo" type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
        <Button size="small" variant="contained" color="secondary" onClick={addXLS}>
          Importar Excel
        </Button>
        <a href={downalodFIle} download style={{ fontSize: "13px" }}>Download Modelo</a>
      </div>
      <div className="cust-title">Importar Categorias</div>
      <div className="cust-card">
        <div className="cust-section-header">Informações para importação</div>
        <div style={{ padding: "16px", fontSize: "13px", color: "#555" }}>
          <p>1. O arquivo deve ser utilizado na mesma estrutura de download.</p>
        </div>
        <div style={{ padding: "16px" }}>
            <CustomGrid
              gridId="importCategory"
              getRowId={(row) => row.category + row.subCategory}
              rows={dataXLS}
              columns={columns}
              pageSize={8}
              tableHeight="500px"
            />
          </div>
        </div>
    </div>
  );
}
